import clsx from 'clsx';

export default function SeverityBadge({ severity }: { severity: string }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-bold',
        severity === 'red' && 'bg-risk-red-soft text-risk-red',
        severity === 'yellow' && 'bg-risk-yellow-soft text-risk-yellow',
        severity === 'green' && 'bg-brand-soft text-brand-deep'
      )}
    >
      <span
        className={clsx(
          'h-1.5 w-1.5 rounded-full',
          severity === 'red' && 'bg-risk-red',
          severity === 'yellow' && 'bg-risk-yellow',
          severity === 'green' && 'bg-brand'
        )}
      />
      {severity === 'red' ? 'Kritisch' : severity === 'yellow' ? 'Warnung' : 'OK'}
    </span>
  );
}
